module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "col-xs-12 block reflexiones"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', {
    staticClass: "block__title"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 reflexiones__slid"
  }, _vm._l((_vm.podcasts), function(podcast) {
    return _c('div', {
      staticClass: "reflexiones__item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'post',
          params: {
            name: podcast.slug
          }
        }
      }
    }, [(podcast.better_featured_image !== null) ? _c('figure', [_c('img', {
      attrs: {
        "src": podcast.better_featured_image.media_details.sizes['536x412'].source_url,
        "alt": ""
      }
    })]) : (podcast.featured_image_src['full'][0]) ? _c('figure', [_c('img', {
      attrs: {
        "src": podcast.featured_image_src['full'][0],
        "alt": ""
      }
    })]) : _c('figure', [_c('img', {
      attrs: {
        "src": _vm.theme_url + '/html/assets/img/ref-slid.jpg',
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "reflexiones__title paused"
    }, [_c('button', {
      staticClass: "reflexiones__player",
      attrs: {
        "audio": podcast.post_meta_fields._enclosure_mp3
      }
    }, [_c('i', {
      staticClass: "icon play-mini"
    })]), _vm._v(" "), _c('h3', {
      domProps: {
        "innerHTML": _vm._s(podcast.title.rendered)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "reflexiones__compartir compartir__player"
    }, [_vm._m(0, true), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
      attrs: {
        "href": 'https://www.facebook.com/sharer/sharer.php?u=' + podcast.link,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-facebook"
    })])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": 'https://twitter.com/share?url=' + podcast.link + '&text=' + podcast.title.rendered,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-twitter"
    })])]), _vm._v(" "), _c('li', {
      staticClass: "itemwa"
    }, [_c('a', {
      attrs: {
        "href": 'whatsapp://send?text=' + podcast.link
      }
    }, [_c('i', {
      staticClass: "fa fa-whatsapp"
    })])])])])], 1)
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', [_vm._v("Compartir en "), _c('i', {
    staticClass: "icon share"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5af9ec2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/audiosportada.vue
// module id = 136
// module chunks = 0